// extracted by mini-css-extract-plugin
export default {"headline":"SystemRequirementType_headline__T77ZB","selection":"SystemRequirementType_selection__e8Rac"};